import React from "react";
import HeroSection from "./HeroSection";
import OverviewSection from "./OverviewSection";
import "./HomePage.css";
import RoutesPage from "../RoutesComponents/RoutesPage";
import Contact from "../ContactUsComponents/Contact";

const HomePage = () => {
  return (
    <div className="staffline-home-page">
      
      <HeroSection />
      <OverviewSection />
      <RoutesPage/>
      <Contact/>

      
    </div>
  );
};

export default HomePage;